import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ACK_KEY = "anatradex-trial-ended-ack";

export const TrialEndedModal = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(ACK_KEY) === "1"; } catch { return false; }
  });

  const now = new Date();
  const subExpired =
    user &&
    !user.is_founder &&
    !user.founder_lifetime &&
    user.tier === "free" &&
    user.subscription_ends_at &&
    new Date(user.subscription_ends_at) < now;

  const trialExpired =
    user &&
    !user.is_founder &&
    !user.on_trial &&
    user.tier === "free" &&
    user.trial_ends_at &&
    new Date(user.trial_ends_at) < now;

  const expired = subExpired || trialExpired;

  if (!expired || dismissed) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(ACK_KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="trial-ended-modal">
      <div className="max-w-md w-full panel p-8 relative border border-accent-blue/30">
        <button onClick={dismiss} className="absolute top-4 right-4 text-white/40 hover:text-white" data-testid="trial-ended-close" aria-label="Fermer">
          <X size={18} />
        </button>
        <div className="w-12 h-12 rounded-xl bg-accent-blue/15 border border-accent-blue/30 flex items-center justify-center mb-5">
          <Sparkles className="text-accent-blue" size={22} />
        </div>
        <h2 className="font-heading font-bold text-2xl mb-3">
          {subExpired ? "Votre abonnement a expiré" : "Votre période de test est terminée"}
        </h2>
        {subExpired ? (
          <p className="text-white/70 text-sm leading-relaxed mb-4" data-testid="sub-expired-message">
            Votre période payée est arrivée à son terme. <b className="text-white">Réabonnez-vous pour
            retrouver l'accès complet</b> — la réactivation est immédiate et vos données sont conservées.
          </p>
        ) : (
          <p className="text-white/70 text-sm leading-relaxed mb-4">
            J'espère que l'expérience vous a plu. Si vous voulez <b className="text-white">continuer
            l'aventure et nous aider à bâtir le futur d'ANATRADEX</b>, voici nos offres d'abonnement.
          </p>
        )}
        <p className="text-white/50 text-xs leading-relaxed mb-6">
          Votre compte reste actif en version Free (1 rapport/mois sur trades importés) —
          vos données et votre historique sont conservés.
        </p>
        <div className="flex flex-col gap-2.5">
          <Link to="/pricing" onClick={dismiss} className="btn btn-primary justify-center py-3" data-testid="trial-ended-pricing-cta">
            {subExpired ? "Me réabonner" : "Voir les offres d'abonnement"}
          </Link>
          <button onClick={dismiss} className="text-xs text-white/50 hover:text-white transition py-1" data-testid="trial-ended-continue-free">
            Continuer en version Free
          </button>
        </div>
      </div>
    </div>
  );
};
